import styled from 'styled-components';

export const DotsLoaderStyled = styled.div``;
